const contexts: Record<string, Console> = {};

export const log = (contextName: string): Console => {
  if (contexts[contextName]) {
    return contexts[contextName];
  }

  return new Proxy<Console>(console, {
    get: (_target, property: "error" | "info" | "warn") => {
      return (...args: unknown[]) => {
        args.unshift(`[${contextName}]`);
        globalThis.console[property](...args);
      };
    },
  });
};
